import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabaseClient";
import { useAuth } from "@/admin/hooks/useAuth";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { user, loading: authLoading } = useAuth();

  useEffect(() => {
    if (!authLoading && user) navigate("/admin", { replace: true });
  }, [user, authLoading, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!supabase) {
      setError("Supabase bağlantısı yapılandırılmamış.");
      return;
    }
    setError("");
    setLoading(true);
    const { error: authError } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    if (authError) {
      setError("E-posta veya şifre hatalı.");
      setLoading(false);
    } else {
      navigate("/admin", { replace: true });
    }
  };

  if (authLoading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="w-5 h-5 border-2 border-[#C5A059] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <p className="text-[#C5A059] text-[10px] tracking-[0.3em] uppercase mb-2">
            Konyap Mühendislik
          </p>
          <h1 className="text-[#F5F5F7] text-2xl font-light tracking-wide">
            Yönetim Paneli
          </h1>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-[#0a0a0a] border border-white/8 p-8 space-y-5"
        >
          <div>
            <label className="block text-[10px] tracking-widest text-[#86868B] uppercase mb-2">
              E-Posta
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              className="w-full bg-[#111] border border-white/10 text-[#F5F5F7] text-sm px-4 py-3 focus:outline-none focus:border-[#C5A059] transition-colors"
            />
          </div>

          <div>
            <label className="block text-[10px] tracking-widest text-[#86868B] uppercase mb-2">
              Şifre
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full bg-[#111] border border-white/10 text-[#F5F5F7] text-sm px-4 py-3 focus:outline-none focus:border-[#C5A059] transition-colors"
            />
          </div>

          {error && <p className="text-red-400 text-xs">{error}</p>}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#C5A059] hover:bg-[#D4AF37] disabled:opacity-50 text-black text-[11px] font-semibold tracking-widest uppercase py-3 transition-colors duration-200"
          >
            {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </button>
        </form>

        <p className="text-center text-[#2a2a2a] text-[11px] mt-8">
          konyapmuhendislik.com
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
